
// import { SVGProps } from "react";
// const HalfLine = (props: SVGProps<SVGSVGElement>) => (
//   <svg
//     width={218}
//     height={2}
//     viewBox="0 0 218 2"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//     {...props}
//   >
//     <path
//       d="M218 0.999981L0 1"
//       stroke="#E4E1EC"
//       strokeWidth={2}
//       strokeDasharray="10 10"
//     />
//   </svg>
// );
// export default HalfLine;

import { useState, useEffect } from "react";

interface HalfLineProps {
  isActive?: boolean;
  className?: string;
}

const HalfLine = ({ isActive = false, className = "" }: HalfLineProps) => {
  const [pathLength, setPathLength] = useState(0);
  const activeColor = "#8FE45A";
  const inactiveColor = "rgb(var(--pd-rule))";

  useEffect(() => {
    if (isActive) {
      const timer = setTimeout(() => {
        setPathLength(1);
      }, 300);
      return () => clearTimeout(timer);
    } else {
      setPathLength(0);
    }
  }, [isActive]);

  return (
    <svg
      width={218}
      height={2}
      viewBox="0 0 218 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Static dashed background line */}
      <path
        d="M218 1L0 1"
        stroke={inactiveColor}
        strokeWidth={2}
        strokeDasharray="10 10"
      />
      
      {/* Animated solid path */}
      <path
        d="M218 1L0 1"
        stroke={activeColor}
        strokeWidth={3}
        strokeDasharray="218"
        strokeDashoffset={218 - (pathLength * 218)}
        style={{ transition: "stroke-dashoffset 2s ease-in-out" }}
      />
    </svg>
  );
};

export default HalfLine;
